var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.468,
    height: 29.468,
    viewBox: "0 0 29.468 29.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8392",
    "data-name": "Rectangle 8392",
    width: 29.468,
    height: 29.468,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16034",
    "data-name": "Group 16034",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M16.285,0a.776.776,0,0,0-.776.775V13.183a.775.775,0,0,0,.776.775H28.693a.775.775,0,0,0,.775-.775A13.2,13.2,0,0,0,16.285,0m-3.1,3.1A13.183,13.183,0,1,0,26.366,16.285a.775.775,0,0,0-.775-.775H13.959V3.877a.775.775,0,0,0-.775-.775m-.775,1.577V16.285a.776.776,0,0,0,.775.776H24.789A11.634,11.634,0,1,1,12.408,4.679",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunSummary);
export default __webpack_public_path__ + "static/media/run-summary.7c89da14eb9b72532d960469db923480.svg";
export { ForwardRef as ReactComponent };